import $ from 'jquery';
import 'slick-carousel/slick/slick';
import '../../../source/scripts/scrollUp.js';
import { lazyLoadJavascripts } from '../../../source/scripts/helpers/lazy';
import { BREAKPOINTS } from '@/scripts/helpers/constants';
import { accordion } from '../../../source/modules/containers/accordion/index';

const { TABLET_XL, DESKTOP_XS } = BREAKPOINTS;
const OPEN = 'is-open';
const NO_SCROLL = 'no-scroll';
const burger = $('.js-burger');
const menuItem = $('.menu__item--has-child');
const body = $('body');
const mobileMenu = $('.menu');

burger.click(() => {
  burger.toggleClass(OPEN);
  mobileMenu.toggleClass(OPEN);
  body.toggleClass(NO_SCROLL);
});

menuItem.click(() => {
  menuItem.toggleClass(OPEN);
});

const initSlider = (selector, arrowPrev, arrowNext) => {
  if (selector) {
    selector.not('.slick-initialized').slick({
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 9999999,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            rows: 3,
          },
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            rows: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: arrowPrev,
            adaptiveHeight: true,
            nextArrow: arrowNext,
            rows: 8,
          },
        },
      ],
    });
  }
};

const showAdvantage = () => {
  $('.js-section-advantage').toggleClass('is-open');
};
$('.js-advantage-show, .js-advantage-hide').on('click', showAdvantage);

$(document).ready(() => {
  accordion();
  initSlider($('.js-forms-slider'), $('.slider-arrow--prev'), $('.slider-arrow--next'));

  $(window).on('resize', () => {
    initSlider($('.js-forms-slider'), $('.slider-arrow--prev'), $('.slider-arrow--next'));
  });
});

window.$ = $;
window.lazyLoadJavascripts = lazyLoadJavascripts;
